import {
  Role,
  ListRoleRequest,
  RoleServiceClient,
  DeleteRoleRequest,
} from '../proto/usrpb/role_grpc_web_pb';
import { auth } from '../lib/auth/Auth';
import { Pagination } from '../proto/utilspb/pagination_pb';
import { Empty } from '../google/protobuf/empty_pb';

const service = new RoleServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listRole(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListRoleRequest();
    req.setRoleId(param.roleId || 0);
    req.setUsrId(param.usrId || 0);
    req.setAccountId(param.accountId || 0);
    req.setPageId(param.pageId || 0);

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    service.listRole(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function lazyListRole() {
  return new Promise((resolve, reject) => {
    service.lazyListRole(new Empty(), {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function createRole(param) {
  return new Promise((resolve, reject) => {
    let req = new Role();
    req.setRoleId(param.roleId);
    req.setRoleName(param.roleName);

    service.createRole(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateRole(param) {
  return new Promise((resolve, reject) => {
    let req = new Role();
    req.setRoleId(param.roleId);
    req.setRoleName(param.roleName);

    service.updateRole(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function deleteRole(param) {
  return new Promise((resolve, reject) => {
    let req = new DeleteRoleRequest();
    req.setRoleId(param.roleId);

    service.deleteRole(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
